import { useNavigate } from "react-router-dom";
import { AnimateOnScroll } from "../../components/animate";
import { Button } from "../../components/buttons/button";
import { useWebsiteButton } from "../../customeHooks/useWebsiteButtons";

export const LandingPage = ({ isSignedIn }: { isSignedIn: boolean }) => {
  const { goToSignup, goToDashboard } = useWebsiteButton();

  const navigate = useNavigate();

  return (
    <div className="md:pt[105px] relative flex max-h-full flex-1 flex-col pt-[72px]">
      <div className="max-width-website relative z-[1]">
        <div className="mx-auto flex w-full max-w-[453px] flex-col items-center justify-center gap-4 text-center">
          <AnimateOnScroll animation="fade-up" delay={0.25}>
            <div className="relative">
              <h1 className="website-title">
                <span className="text-blue">Host Events,</span>
                <br />
                Get Paid the
                <br />
                Next Day
              </h1>
              <img
                src="/assets/images/sparkles.png"
                alt="sparkles"
                className="absolute left-0 top-[50%] max-w-[32px] md:max-w-[49px]"
              />
              <img
                src="/assets/images/ticket.png"
                alt="sparkles"
                className="absolute right-[-10px] top-[25%] max-w-[32px] md:right-[-30px] md:top-[20%] md:max-w-[49px]"
              />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fade-up" delay={0.5}>
            <p className="website-title-text">
              No more waiting weeks for ticket payouts—your earnings are paid
              into your bank account the very next day.
            </p>
          </AnimateOnScroll>

          <AnimateOnScroll
            animation="fade-up"
            delay={0.75}
            className="mt-4 flex flex-col items-center justify-center gap-2.5 md:flex-row"
          >
            <Button
              text={isSignedIn ? "Go to Dashboard" : "Create a Free Event"}
              onClick={() => {
                if (isSignedIn) {
                  goToDashboard();
                } else {
                  goToSignup();
                }
              }}
              type="button"
              variation="primary"
              className="glossy-button !min-w-fit !px-5 !py-4"
            />

            <Button
              text="Find Events"
              onClick={() => {
                navigate("/");
              }}
              type="button"
              variation="plain-grey-2"
              className="shadow-button !min-w-fit !bg-[#F3F5F84D] !px-5 !py-4"
              icon="search"
              iconDimension={24}
            />
          </AnimateOnScroll>
        </div>
      </div>

      <AnimateOnScroll
        animation="fade-up"
        delay={1}
        className="bottom-0 left-0 right-0 flex flex-1 items-end justify-center"
      >
        <div className="">
          <img
            src="/assets/images/mockupDes.png"
            alt="mockup"
            className="hidden object-cover md:block"
          />
          <img
            src="/assets/images/mockup.png"
            alt="mockup"
            className="block object-cover md:hidden"
          />
        </div>
      </AnimateOnScroll>
    </div>
  );
};
